import { Component, computed, inject } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { FilterSelectorDialogComponent } from '../filter-selector-dialog/filter-selector-dialog.component';
import { FilterSnapshotService } from '../services/filter-snapshot.service';
import { ToastService } from '../services/toast.service';
import { ItemDataService } from '../services/item-data.service';
import { resolveActiveFilterIcons } from '../services/active-filter-icons';

@Component({
  selector: 'app-active-filter',
  imports: [FilterSelectorDialogComponent],
  templateUrl: './active-filter.component.html',
  styleUrl: './active-filter.component.scss'
})
export class ActiveFilterComponent {
  showFilterSelectorDialog = false;

  readonly filterService = inject(FilterService);
  private readonly filterSnapshotService = inject(FilterSnapshotService);
  private readonly toastService = inject(ToastService);
  private readonly allWeaponClasses = inject(ItemDataService).getAllWeaponTypes();

  readonly activeFilterIcons = computed(() => {
    this.filterService.dirtyFilterUpdated();
    const stored = this.filterService.activeFilter();
    return resolveActiveFilterIcons(stored, this.allWeaponClasses).icons;
  });

  changeFilter($event: Event) {
    $event.preventDefault();
    this.showFilterSelectorDialog = true;
  }

  copyShareLink($event: Event) {
    $event.preventDefault();
    const url = this.filterSnapshotService.buildShareUrl(this.filterService.activeFilter());
    if (!url) return;

    void navigator.clipboard.writeText(url).then(() => {
      this.toastService.raise('success', 'Share link copied to clipboard.');
    });
  }
}
